import { render, staticRenderFns } from "./CourseWishes.vue?vue&type=template&id=25971ef4"
import script from "./CourseWishes.vue?vue&type=script&lang=js"
export * from "./CourseWishes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports